import PropTypes from 'prop-types'

import classes from './ContactInfo.module.scss'
import classNames from 'classnames'

const ContactInfo = ({ fullName, familyAdminsNames, familyAdminsEmails, email, phone }) => (
  <div className={classes.container}>
    <h5 className={classes.heading}>Contact Information</h5>
    <div className={classes.row}>
      <p className={classes.label}>Golfer</p>
      <p className={classes.value}>{fullName || '-'}</p>
    </div>
    <div className={classes.row}>
      <p className={classes.label}>Family Admin{familyAdminsNames.length > 1 ? 's' : ''}</p>
      <ul className={classes.multipleValueList}>
        {familyAdminsNames.map((fullName, idx) => (
          <li key={idx}>
            <p className={classNames(classes.value, 'mb-1')}>{fullName}</p>
          </li>
        ))}
      </ul>
    </div>
    <div className={classes.row}>
      <p className={classes.label}>{email ? 'Email' : 'Family Admins Emails'}</p>
      {email ? (
        <p className={classes.value}>{email}</p>
      ) : (
        <ul className={classes.multipleValueList}>
          {familyAdminsEmails.map((email, idx) => (
            <li key={idx}>
              <p className={classNames(classes.value, 'mb-1')}>{email}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
    <div className={classes.row}>
      <p className={classes.label}>Phone Number</p>
      <p className={classes.value}>{phone || '-'}</p>
    </div>
  </div>
)

ContactInfo.propTypes = {
  fullName: PropTypes.string,
  familyAdminsNames: PropTypes.arrayOf(PropTypes.string),
  familyAdminsEmails: PropTypes.arrayOf(PropTypes.string),
  email: PropTypes.string,
  phone: PropTypes.string,
}

export default ContactInfo
